import {
  IconButton,
  Menu,
  MenuItem,
  Paper,
  PopoverOrigin,
  Typography,
  useTheme,
} from "@material-ui/core";
import { CheckBox, CheckBoxOutlineBlank, Settings } from "@material-ui/icons";
import { MouseEventHandler, useState } from "react";

const AnchorOrigin: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "right",
};

const TransformOrigin: PopoverOrigin = {
  vertical: "top",
  horizontal: "right",
};

interface Props {
  loading?: boolean;
  clusteringEnabled?: boolean;
  onSetClusteringEnabled?: (value: boolean) => void;
}

export const DashboardMapSettings = ({
  clusteringEnabled,
  onSetClusteringEnabled,
  loading,
}: Props) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenu: MouseEventHandler<HTMLButtonElement> = (event) =>
    setAnchorEl((x) => (x ? null : event.currentTarget));
  const handleClose = () => setAnchorEl(null);
  const handleClick = () => onSetClusteringEnabled?.(!clusteringEnabled);

  if (loading) {
    return null;
  }

  return (
    <div className="dashboard-map-settings">
      <Paper
        className="dashboard-map-settings-button"
        style={{ backgroundColor: theme.palette.background.paper }}
      >
        <IconButton onClick={handleMenu}>
          <Settings />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={AnchorOrigin}
          transformOrigin={TransformOrigin}
          getContentAnchorEl={null}
          open={menuOpen}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClick}>
            <div className="dashboard-map-settings-menu-item">
              {clusteringEnabled ? <CheckBox /> : <CheckBoxOutlineBlank />}
              <Typography variant="body2">Enable clustering</Typography>
            </div>
          </MenuItem>
        </Menu>
      </Paper>
    </div>
  );
};
